<template>
  <div class="select-type" :style="{height: viewportHeight}">
    <HomeHeader :scrollTop="300"></HomeHeader>
    <div class="flex-column container w-wrapper">
      <div class="flex-column main">
        <div @click="goBack()" class="back">返回</div>
        <div class="title">选择公会类型</div>
        <div @click="goStepOne('1')" class="flex-row-h-center type-item">
          <div class="item-left">
            <img src="@/assets/type/company.png" alt="">
          </div>
          <div class="item-center">
            <div class="center-title">企业公会</div>
            <div class="flex-row-h-center center-dec">营业执照</div>
            <div class="flex-row-h-center center-dec">负责人身份信息</div>
            <div class="flex-row-h-center center-dec">>5个达人主播</div>
          </div>
          <div class="item-right">
            <img src="@/assets/type/arrow-type.png" alt="">
          </div>
        </div>
        <div @click="goStepOne('2')" class="flex-row-h-center type-item">
          <div class="item-left">
            <img src="@/assets/type/mine.png" alt="">
          </div>
          <div class="item-center">
            <div class="center-title">个人公会</div>
            <div class="flex-row-h-center center-dec">负责人身份信息</div>
            <div class="flex-row-h-center center-dec">>5个达人主播</div>
          </div>
          <div class="item-right">
            <img src="@/assets/type/arrow-type.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "@/views/home/components/home-header";

export default {
  name: "select-type",
  components: {HomeHeader},
  data() {
    return {
      viewportHeight: '100vh'
    }
  },
  mounted() {
    let viewportHeight = document.documentElement.clientHeight;
    this.viewportHeight = viewportHeight + 'px'
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    goStepOne(type) {
      this.$router.replace({
        path: '/apply/step-one',
        query: {
          mcnType: type
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-type {
  position: relative;
  overflow: hidden;
  background-image: url("~@/assets/banner.png");
  background-size: 100% 600px;
  background-repeat: no-repeat;
}

.container {
  margin: 60px auto 0;
  height: calc(100% - 100px);

  .main {
    position: relative;
    overflow-y: hidden;
    flex: 1;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 32px;
    border-radius: 4px;
    background-color: #ffffff;

    .back {
      position: absolute;
      top: 20px;
      left: 20px;
      color: #409EFF;
      cursor: pointer;
    }

    .title {
      margin-bottom: 60px;
      font-size: 24px;
      text-align: center;
      font-weight: bold;
    }

    .type-item {
      margin: 20px 0;
      padding: 32px 32px;
      background-color: #f8f8f8;
      border-radius: 5px;
      border: 1px solid transparent;
      cursor: pointer;

      &:hover {
        border-color: #409EFF;
      }

      .item-left {

        img {
          width: 50px;
          height: 50px;
        }
      }

      .item-center {
        flex: 1;
        padding-left: 32px;

        .center-title {
          margin-bottom: 10px;
          font-size: 18px;
          font-weight: bold;
        }

        .center-dec {
          font-size: 14px;
          color: #999999;

          &:before {
            content: ' ';
            width: 6px;
            height: 6px;
            margin-right: 5px;
            border-radius: 100px;
            background-color: #334bd4;
          }
        }
      }

      .item-right {

        img {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}
</style>